document.addEventListener("DOMContentLoaded", function() {
    document.querySelectorAll('.custom-site-btn').forEach(button => {
        if (button.__boundAddToCart) return;
        button.__boundAddToCart = true;
        button.addEventListener('click', function (event) {
            event.preventDefault();
            if (button.dataset.adding === '1') return;
            button.dataset.adding = '1';
            setTimeout(function () { button.dataset.adding = ''; }, 1500);
            let variantId = this.getAttribute('data-variant-id');
            let quantity = this.closest('.count-add-to-cart').querySelector('.quantity').value || 1;
            let cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
            if (variantId) {
                addToCart(variantId, quantity, cart);
            } else {
                console.error("Variant ID is missing.");
            }
        });
    });



function addToCart(variantId, quantity, cart) {
    const formData = {
        'items': [{
            'id': variantId,
            'quantity': quantity
        }],
        'sections': cart.getSectionsToRender().map((section) => section.id),
        'sections_url': window.location.pathname
    };

    fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
    .then((response) => response.json())
    .then(data => {
         if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
             cart.renderContents(data);
             setTimeout(()=> document.querySelector('.drawer__heading')?.click());
    })
    .catch(error => {
        console.error("Error adding item to cart:", error);
    });
}

   document.addEventListener("change", (e) => {
      if (e.target.matches('.featured-product-content input[type="radio"]')) {
        const mainEle = e.target.closest(".featured-product-content");
        const variantId = e.target.getAttribute("variant_id");
        mainEle?.querySelector("button.custom-site-btn")?.setAttribute("data-variant-id", variantId);
      }
    });
});